import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import ProcessManager from '../../../Common/Managers/ProcessManager';

class VolverLink extends Component {
    constructor(props) {
        super(props);

        this.state = { rutearListadoParametros: false, ruta: "" };
        this.rutearListadoParametros = this.rutearListadoParametros.bind(this);
    }

    rutearListadoParametros() {
        this.setState({
            ruta: ProcessManager.GetNextStep("ListadoParametros", "ROUTE_TO_LISTADO_PARAMETROS"),
            rutearListadoParametros: true
        });
    }

    render() {

        if (this.state.rutearListadoParametros == true) {
            return <Redirect push to={this.state.ruta} />;
        }

        return (
            <div className="row">
                <div className="col-xs-12">
                    <a className="btn-link btn-link-atlas btn-link-labeled-primary" onClick={() => this.rutearListadoParametros()}>&#60; Volver a la lista</a>
                </div>
            </div>
        );
    }
};

export default VolverLink